export const CHAT_NSFW_KEY = "__chat_nsfw";
export const CHAT_ID_SETTINGS_KEY = "__chat_id_settings";
